var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "48px_grain"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.16663 24.6865L4.87496 21.9781",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.95825 10.0615L6.01241 10.1157C6.71667 10.8198 7.27532 11.6559 7.65647 12.576C8.03762 13.4961 8.23379 14.4822 8.23379 15.4782C8.23379 16.4741 8.03762 17.4603 7.65647 18.3804C7.27532 19.3005 6.71667 20.1365 6.01241 20.8407L4.87491 21.9782L4.82075 21.924C4.11649 21.2198 3.55783 20.3838 3.17669 19.4637C2.79554 18.5436 2.59937 17.5574 2.59937 16.5615C2.59937 15.5656 2.79554 14.5794 3.17669 13.6593C3.55783 12.7392 4.11649 11.9032 4.82075 11.199L5.95825 10.0615Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.7917 20.8948L16.7375 20.8406C16.0333 20.1364 15.1973 19.5777 14.2772 19.1966C13.3571 18.8154 12.3709 18.6193 11.375 18.6193C10.3791 18.6193 9.39291 18.8154 8.47281 19.1966C7.5527 19.5777 6.71669 20.1364 6.0125 20.8406L4.875 21.9781L4.92917 22.0323C5.63335 22.7366 6.46937 23.2952 7.38947 23.6764C8.30957 24.0575 9.29574 24.2537 10.2917 24.2537C11.2876 24.2537 12.2738 24.0575 13.1939 23.6764C14.114 23.2952 14.95 22.7366 15.6542 22.0323L16.7917 20.8948Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.9166 14.9365L11.7963 14.8162C10.679 13.6988 10.0513 12.1834 10.0513 10.6032C10.0513 9.02296 10.679 7.50747 11.7963 6.39008L12.9999 5.18649L13.1202 5.30674C14.2375 6.42414 14.8652 7.93962 14.8652 9.51983C14.8652 11.1 14.2375 12.6155 13.1202 13.7329L11.9166 14.9365Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.9166 14.9365L12.0369 15.0567C13.1543 16.1741 14.6698 16.8018 16.25 16.8018C17.8302 16.8018 19.3456 16.1741 20.463 15.0567L21.6666 13.8532L21.5464 13.7329C20.429 12.6156 18.9135 11.9879 17.3333 11.9879C15.7531 11.9879 14.2376 12.6156 13.1202 13.7329L11.9166 14.9365Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.9583 4.64478C20.5671 3.03603 23.8333 3.01978 23.8333 3.01978C23.8333 3.01978 23.8171 6.28603 22.2083 7.89478C20.5996 9.50353 17.875 8.97811 17.875 8.97811C17.875 8.97811 17.3496 6.25353 18.9583 4.64478Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.aa1a053ef905eb0c8fbdca85a2af8509.svg";
export { ForwardRef as ReactComponent };